import {ConnectedPosition} from '@angular/cdk/overlay';

/** The form-control value / backend contract — same as a native `input[type=date]`. */
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Typed input tolerated in either profile, most canonical first — the same set the period selector
 * accepts, so both fields parse a hand-typed date identically. The field shows the `date` display
 * format (`YYYY.MM.DD` by default), which is the first of these.
 */
export const DATE_INPUT_FORMATS = ['YYYY.MM.DD', 'YYYY.MM.DD.', 'YYYY.M.D', 'YYYY-MM-DD', 'YYYY/MM/DD', 'YYYYMMDD'];

/**
 * Also tolerated in the US profile, ahead of {@link DATE_INPUT_FORMATS}: the `date` display format
 * the field then shows (`Sep 4 2026`) and the common US spellings. Month-first `M/D/YYYY` is US
 * only — elsewhere a slashed date reads day-first.
 */
export const US_DATE_INPUT_FORMATS = ['MMM D YYYY', 'MMM D, YYYY', 'M/D/YYYY'];

/** Calendar popup, below the field by default, flipping above / to the end edge when cramped. */
export const DATE_PICKER_POSITIONS: ConnectedPosition[] = [
  {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 0},
  {originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetX: 0, offsetY: 0},
  {originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: 0},
  {originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetX: 0, offsetY: 0},
];
